import { forwardRef } from 'react';
import BlockLoader from 'components/ui/ContentBlocks/BlockLoader';
import { useTranslation } from 'hooks/useTranslation';
import type { TreatmentPage } from 'types/contentful/generated/graphql';

type Props = {
  entry: TreatmentPage;
};

const Costs = forwardRef<HTMLElement, Props>(({ entry }, ref): JSX.Element => {
  const { t } = useTranslation();
  return (
    <section ref={ref} id="costs" className="text-primary">
      <div className="max-w-screen-xl mx-auto px-5 md:px-4">
        <h2 className="font-netto text-navy text-3xl mb-6">
          {entry.costsTitle || t('treatmentPage.costs')}
        </h2>
      </div>
      <BlockLoader entry={entry.costsCollection} />
    </section>
  );
});

Costs.displayName = 'Costs';
export default Costs;
